// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"bf3ff14c","381":"ae2cd85b","392":"eb366227","518":"551cf034","693":"57b05e39","808":"eb366227"}[chunkId] + ".chunk.css";
};